  /**
 * @typedef {Object} RecommendationProduct
 * @property {string} title
 * @property {string} url
 * @property {string} featured_image
 */

/**
 * @typedef {Object} RecommendationResponse
 * @property {RecommendationProduct[]} products
 */

document.addEventListener('DOMContentLoaded', () => {
    /** @type {HTMLElement | null} */
    const container = document.getElementById('complementary-products');
    /** @type {HTMLElement | null} */
    const listContainer = document.getElementById('complementary-products-list');
  
    if (!container || !listContainer) return;
  
    const productId = container.dataset.productId;
    const baseUrl = container.dataset.recommendationsUrl || '/recommendations/products';
    const requestUrl = `${baseUrl}.json?product_id=${productId}&limit=6&intent=complementary`;
  
    fetch(requestUrl)
      .then((response) => {
        if (!response.ok) throw new Error('Failed to load recommendations');
        return response.json();
      })
      .then((/** @type {RecommendationResponse} */ data) => {
        const products = data.products || [];
  
        if (products.length === 0) return;
  
        // Render items cleanly to avoid HTML injection issues
        products.forEach((/** @type {RecommendationProduct} */ product) => {
          const li = document.createElement('li');
          li.className = 'complementary-product-item';
  
          // Image link
          const imgLink = document.createElement('a');
          imgLink.href = product.url;
          imgLink.title = product.title;
          imgLink.className = 'complementary-product-image-link';
  
          const img = document.createElement('img');
          img.src = product.featured_image;
          img.alt = product.title;
          img.width = 120;
          img.height = 120;
          img.className = 'complementary-product-image';
  
          imgLink.appendChild(img);
  
          // Title link
          const titleLink = document.createElement('a');
          titleLink.href = product.url;
          titleLink.className = 'complementary-product-title-link';
          titleLink.textContent = product.title;
  
          li.appendChild(imgLink);
          li.appendChild(titleLink);
  
          listContainer.appendChild(li);
        });
  
        // Show container once products are loaded
        container.hidden = false;
      })
      .catch((error) => {
        console.error('Error fetching complementary products:', error);
      });
  });